export enum SanctionsTabEntityType {
  Vendor,
  Organization
}
